import { TableRowProps } from '@mui/material';
import { StyledTableRow } from './CustomTableRow.styles';

const CustomTableRowComponent = function ({ children, ...props }: TableRowProps): JSX.Element {
  return <StyledTableRow {...props}>{children}</StyledTableRow>;
};

export default CustomTableRowComponent;
